module.exports = __webpack_public_path__ + "static/media/about_image_02.62c74b90.jpg";